import { defineComponent, inject, reactive } from 'vue';
import { withInstall } from '../utils/type';
import theme from './theme';
export var defaultConfigProvider = {
  isDefault: true,
  getPrefixCls: function getPrefixCls(suffixCls, customizePrefixCls) {
    if (customizePrefixCls) {
      return customizePrefixCls;
    }
    return "stepin-".concat(suffixCls);
  },
  prefix: 'stepin',
  theme: reactive(theme)
};
export function useConfigProvider() {
  var configProvider = inject('stepConfigProvider', defaultConfigProvider);
  return configProvider;
}
var StepinConfigProvider = defineComponent({
  name: 'StepinConfigProvider',
  props: {
    getPrefixCls: {
      type: Function,
      default: defaultConfigProvider.getPrefixCls
    },
    theme: {
      type: Object,
      default: function _default() {
        return defaultConfigProvider.theme;
      }
    },
    prefix: {
      type: String,
      default: function _default() {
        return defaultConfigProvider.prefix;
      }
    }
  },
  data: function data() {
    return {
      isDefault: false
    };
  },
  provide: function provide() {
    return {
      stepConfigProvider: this
    };
  },
  render: function render() {
    return this.$slots.default ? this.$slots.default() : null;
  }
});
export default withInstall(StepinConfigProvider);